<div class="dialogue-content">
    <div class="mat-dialogue-header">
    </div>
    <mat-dialog-content>
        <div class="text-center">
            <form novalidate>
                <img [src]="action === 'Manufacture' ? '../../../assets/images/manufacture.svg' : action === 'ReActivate' ? '../../../assets/images/account-reactivate.svg' 
              : '../../../assets/images/delete-icon.svg'" class="mb-4 m-auto d-table" />

                <h5 class="text-primary">{{ action }} {{ type }}</h5>
                <p>
                    Are you sure you want to
                    <span *ngIf="permanent"> permanently</span> {{ action | lowercase }}
                    this {{ type | lowercase }}?
                </p>
                <p *ngIf="warning" class="text-danger small mb-0">{{ warning }}</p>
                <div class="d-flex align-items-center mt-4 flex-wrap justify-content-center gap-3">
                    <button matButton="filled" type="button" class="dialog-btn-secondary" mat-dialog-close
                        (click)="close()">No, Keep it!</button>
                    <button mat-flat-button type="button" class="dialog-btn-primary"
                        *ngIf="action?.toLowerCase().includes('manufacture')" (click)="confirmDelete()">
                        Yes, {{ action }}!
                    </button>
                    <button mat-flat-button type="button" class="dialog-btn-danger"
                        *ngIf="!action?.toLowerCase().includes('manufacture')" (click)="confirmDelete()">
                        Yes, {{ action }}!
                    </button>

                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>